import { render } from "./VisitorSecurityStaffTable.vue?vue&type=template&id=0a490f92"
import script from "./VisitorSecurityStaffTable.vue?vue&type=script&lang=js"
export * from "./VisitorSecurityStaffTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__